export class KsefClientValidatorUtils {
  /**
   * Sprawdza czy kontrahent ma niekompletne dane wymagane do wysyłki faktury do KSeF.
   * Weryfikuje: ulicę, kod pocztowy, miasto, oraz poprawność identyfikatora podatkowego.
   */
  public static hasKsefWarning(client: any): boolean {
    if (!client) return false;
    return this.getKsefWarnings(client).length > 0;
  }

  /**
   * Zwraca listę ostrzeżeń dotyczących danych kontrahenta wymaganych przez KSeF.
   */
  public static getKsefWarnings(client: any): string[] {
    if (!client) return [];
    const warnings: string[] = [];

    // Sprawdź kompletność adresu
    const street = (client.street || '').trim();
    const postalCode = (client.postalCode || '').trim();
    const city = (client.city || '').trim();

    if (!street) warnings.push('Brak ulicy');
    if (!postalCode) warnings.push('Brak kodu pocztowego');
    if (!city) warnings.push('Brak miejscowości');

    // Sprawdź identyfikator podatkowy
    const identifierType = client.identifierType;
    if (identifierType === 'nip' && !client.nip) {
      warnings.push('Typ identyfikatora NIP, ale brak numeru NIP');
    }

    return warnings;
  }

  /**
   * Sprawdza czy kontrahent ma niekompletne dane adresowe
   */
  public static isAddressIncomplete(client: any): boolean {
    if (!client || !client._id) return false;
    const street = (client.street || '').trim();
    const postalCode = (client.postalCode || '').trim();
    const city = (client.city || '').trim();
    return !street || !postalCode || !city;
  }
}
